import { registerRemotes, init, loadRemote } from '@module-federation/enhanced/runtime'

init({
  name: 'app-gateway'
})
const t = Date.now()
const useModule = async ({ from, name }) => {
  const registryName = from.startsWith('/') ? from.slice(1) : from
  const registry = {
    name: registryName,
    entry: from.startsWith('/')
      ? `${location.origin}${from}/mf-manifest.json?t=${t}`
      : `${location.origin}/${from}/mf-manifest.json?t=${t}`
  }
  console.log('registry', registry)
  registerRemotes([registry])
  return {
    use: async () => {
      const r = await loadRemote(registryName)
      const func = await r.default[name]()
      return func.default
    }
  }
}

window.useBehavior = async ({ from, name }) => {
  const behavior = await useModule({
    from,
    name
  })
  // 如果name是数组，则返回一个数组
  if (Array.isArray(name)) {
    return await Promise.all(name.map((n) => behavior.use(n)))
  }
  return await behavior.use(name)
}
